import { render } from "./operator.vue?vue&type=template&id=740fcb45&scoped=true"
import script from "./operator.vue?vue&type=script&lang=js"
export * from "./operator.vue?vue&type=script&lang=js"

import "./operator.vue?vue&type=style&index=0&id=740fcb45&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740fcb45"]])

export default __exports__